import {default as Validator} from './vendor/validator/index';
import {Base} from "./base";
export class BirthYear extends Base {
    constructor(element) {
        super(element);
        this.validator = Validator.isBirthYear;
    }

    isValid() {
        return super.isValid([]);
    }
}
